import $ from 'jquery';
import {trigger} from '../../utils/events';

const HIDE_CLASS = 'jsHide',
    facets = {
        _checkboxes: function () {
            $('.facetLabel').on(
                'change',
                'input[type=checkbox]',
                function (e) {
                    var name = e.target.name;

                    this._handleDataChange({
                        name: name,
                        value: e.target.value,
                        shouldAdd: e.target.checked,
                        isMultiSelect: $(e.target).data('multiselect') === 'True'
                    });

                    if (this._hasSelectionsByName(name)) {
                        this._findClearLink(name).removeClass(HIDE_CLASS);
                    }
                }.bind(this)
            );
        },
        _links: function () {
            $('#facetedSearch, #searchCrumbs').on(
                'click',
                '.facetLink',
                function (e) {
                    e.preventDefault();

                    var $link = $(e.currentTarget),
                        name = $link.data('name'),
                        shouldAdd = $link.data('selected') === 'False',
                        isMultiSelect = $link.data('multiselect') === 'True';

                    this._handleDataChange({
                        name: name,
                        value: $link.data('value').toString(),
                        shouldAdd: shouldAdd,
                        isMultiSelect: isMultiSelect
                    });

                    $link.data('selected', shouldAdd ? 'True' : 'False');

                    if (this._hasSelectionsByName(name)) {
                        this._findClearLink(name).removeClass(HIDE_CLASS);
                    }
                }.bind(this)
            );
        },
        _categoryLinks: function () {
            $('#facetedSearch').on('click', 'a[data-categoryid]:not([href="#"])', e => {
                this._triggerEvent({
                    name: 'category',
                    value: e.target.dataset.categoryid
                });
            });
        },
        _dropdowns: function () {
            $('.facetDropDown').on(
                'change',
                function (e) {
                    this._handleDataChange({
                        name: e.target.name,
                        value: e.target.value,
                        shouldAdd: true,
                        isMultiSelect: true
                    });
                }.bind(this)
            );
        },
        _redirectDropdowns: function () {
            $('.redirectDropDown').on('change', function (e) {
                smartPak.page.redirectToUrl(e.target.value);
            });
        },
        _handleDataChange: function (changeData) {
            const { name, value, isMultiSelect, shouldAdd } = changeData;

            if (shouldAdd) {
                if (typeof this.handleFacetAdd === 'function') {                    
                    this.handleFacetAdd({ name, value, isMultiSelect });
                }
            } else if (typeof this.handleFacetRemove === 'function') {
                this.handleFacetRemove({ name, value, isMultiSelect });
            }
            
            this._triggerEvent({name, value});
        },
        _triggerEvent: function ({name, value}) {
            trigger('Facet Interaction', name, value);
        },
        _clearLinks: function () {
            $('.facetUndoAll').on(
                'click',
                function (e) {
                    e.preventDefault();
                    
                    var $link = $(e.target),
                        name = $link.data('name');

                    $link.addClass(HIDE_CLASS);

                    this._handleDataChange({
                        name: name,
                        value: '',
                        shouldAdd: false,
                        isMultiSelect: false
                    });

                    this._clear(name);
                }.bind(this)
            );
        },
        _hasSelectionsByName: function (name) {
            return this._findSelectedByName(name).length > 0;
        },
        _hasSelection: function ($item) {
            return $item.data('Selected') === 'True' || $item.prop('checked');
        },
        _findSelectedByName: function (name) {
            return this._findByName(name).filter(
                function (index, item) {
                    return this._hasSelection($(item));
                }.bind(this)
            );
        },
        _findByName: function (name) {
            return $('[data-name=' + name + ']:not(.facetUndoAll), [name=' + name + ']:not(.facetUndoAll)');
        },
        _findClearLink: function (name) {
            return $('.facetUndoAll[data-name=' + name + ']');
        },
        _clear: function (name) {
            this._findSelectedByName(name).each(function (index, item) {
                var $item = $(item);
                $item.prop('checked', false).data('Selected', 'False');
            });
        },
        _expandFacetLink: function (name) {
            var facetName = name.charAt().toUpperCase() + name.slice(1),
                $facetElement = $('#facetRefine-' + facetName);

            if ($facetElement.length) {
                $facetElement.children('a').eq(0).trigger('click', 'jqueryTrigger');
            }
        },
        _expandFacetsFromLocalStorage: function () {
            if (this.viewAllFacetsData.facets) {
                this.viewAllFacetsData.facets.forEach(
                    function (facet) {
                        this._expandFacetLink(facet);
                    }.bind(this)
                );
            }
        },
        _bindViewAllLinks: function () {
            $('.facetSelect')
                .next('a')
                .on(
                    'click',
                    function (e, source) {
                        if (source !== 'jqueryTrigger') {
                            var $link = $(e.target),
                                facetId = $link.parent().attr('id'),
                                facetName,
                                facetIndex;

                            if (facetId) {
                                facetName = facetId.replace('facetRefine-', '');
                                if (this.viewAllFacetsData.facets) {
                                    facetIndex = this.viewAllFacetsData.facets.indexOf(facetName);
                                    if (facetIndex === -1) {
                                        this.viewAllFacetsData.facets.push(facetName);
                                    } else {
                                        this.viewAllFacetsData.facets.splice(facetIndex, 1);
                                    }
                                }
                                window.localStorage.setItem('viewAllFacets', JSON.stringify(this.viewAllFacetsData));
                            }
                        }
                    }.bind(this)
                );
        },
        _initViewAllFacets: function () {
            var viewAllFacetsData = (this.viewAllFacetsData = JSON.parse(window.localStorage.getItem('viewAllFacets'))),
                pageTitle = $('#h1Title').text().trim(),
                setViewAllFacetsData;

            if (!viewAllFacetsData || !viewAllFacetsData.page || viewAllFacetsData.page !== pageTitle) {
                setViewAllFacetsData = {
                    page: pageTitle,
                    facets: []
                };
                this.viewAllFacetsData = setViewAllFacetsData;
                window.localStorage.setItem('viewAllFacets', JSON.stringify(setViewAllFacetsData));
            }
        },
        init: function ({ activeFacetNames, handleFacetAdd, handleFacetRemove }) {
            this.handleFacetAdd = handleFacetAdd;
            this.handleFacetRemove = handleFacetRemove;

            this._checkboxes();
            this._links();
            this._categoryLinks();
            this._dropdowns();
            this._clearLinks();
            this._redirectDropdowns();
            this._initViewAllFacets();
            this._bindViewAllLinks();

            if (Array.isArray(activeFacetNames)) {
                activeFacetNames.forEach(name => this._findClearLink(name).removeClass(HIDE_CLASS));
            }
            
            this._expandFacetsFromLocalStorage();
        }
    };

export default facets;
